import { fetch } from '@/common/request';

// 提示词模板
export interface PromptTemplateVo {
  id: number;
  name: string;
  description?: string;
  currentVersionId?: number;
  currentVersion?: string;
  createdBy?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface PromptTemplateCreateReq {
  name: string;
  description?: string;
}

export interface PromptTemplateUpdateReq extends PromptTemplateCreateReq {
  id: number;
}

export interface PromptTemplateListReq {
  keyword?: string;
}

// 提示词版本
export interface PromptVersionVo {
  id: number;
  templateId: number;
  version: string;
  content: string;
  changeLog?: string;
  createdBy?: string;
  createdAt?: string;
  updatedBy?: string;
  updatedAt?: string;
}

export interface PromptVersionCreateReq {
  templateId: number;
  version: string;
  content: string;
  changeLog?: string;
}

export interface PromptVersionUpdateReq {
  id: number;
  content: string;
  changeLog?: string;
}

export interface PromptVersionListReq {
  templateId: number;
}

export interface PromptVersionSwitchReq {
  templateId: number;
  versionId: number;
}

// 版本对比结果
export interface CompareResultVo {
  fromVersionId: number;
  toVersionId: number;
  fromContent: string;
  toContent: string;
  diff: DiffItemVo[];
}

export interface DiffItemVo {
  type: 'add' | 'delete' | 'modify';
  lineNumber: number;
  content: string;
}

export interface PromptVersionCompareReq {
  fromVersionId: number;
  toVersionId: number;
}

// 模板 API
export function createPromptTemplate(params: PromptTemplateCreateReq): Promise<number> {
  return fetch(
    '/api/config/prompt/template/create',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

export function updatePromptTemplate(params: PromptTemplateUpdateReq): Promise<void> {
  return fetch(
    '/api/config/prompt/template/update',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

export function deletePromptTemplate(id: number): Promise<void> {
  return fetch(
    '/api/config/prompt/template/delete',
    {
      method: 'POST',
      body: JSON.stringify({ id }),
    },
    true
  );
}

export function getPromptTemplateDetail(id: number): Promise<PromptTemplateVo> {
  return fetch(
    '/api/config/prompt/template/detail',
    {
      method: 'POST',
      body: JSON.stringify({ id }),
    },
    true
  );
}

export function getPromptTemplateList(params?: PromptTemplateListReq): Promise<PromptTemplateVo[]> {
  return fetch(
    '/api/config/prompt/template/list',
    {
      method: 'POST',
      body: JSON.stringify(params || {}),
    },
    true
  );
}

// 版本 API
export function createPromptVersion(params: PromptVersionCreateReq): Promise<number> {
  return fetch(
    '/api/config/prompt/version/create',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

export function updatePromptVersion(params: PromptVersionUpdateReq): Promise<void> {
  return fetch(
    '/api/config/prompt/version/update',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

export function deletePromptVersion(id: number): Promise<void> {
  return fetch(
    '/api/config/prompt/version/delete',
    {
      method: 'POST',
      body: JSON.stringify({ id }),
    },
    true
  );
}

export function switchPromptVersion(params: PromptVersionSwitchReq): Promise<void> {
  return fetch(
    '/api/config/prompt/version/switch',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

export function getPromptVersionList(templateId: number): Promise<PromptVersionVo[]> {
  return fetch(
    '/api/config/prompt/version/list',
    {
      method: 'POST',
      body: JSON.stringify({ templateId }),
    },
    true
  );
}

export function getPromptVersionDetail(id: number): Promise<PromptVersionVo> {
  return fetch(
    '/api/config/prompt/version/detail',
    {
      method: 'POST',
      body: JSON.stringify({ id }),
    },
    true
  );
}

export function comparePromptVersions(params: PromptVersionCompareReq): Promise<CompareResultVo> {
  return fetch(
    '/api/config/prompt/version/compare',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}